(function () {
  if (window.__lmHomeInit) return;
  window.__lmHomeInit = true;

  var addUrl = function () { return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js'; };
  var changeUrl = function () { return ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js'; };
  var cartUrl = function () { return (window.routes && window.routes.cart_url) || '/cart'; };

  /* ---------------- Mini cart (LM cart drawer) ---------------- */
  function miniCart() { return document.querySelector('[data-lm-cd]'); }

  function updateCount(count) {
    document.querySelectorAll('[data-lm-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? (count < 100 ? count : '99+') : '';
    });
  }

  function renderMiniCart(html, showAdded) {
    var cd = miniCart();
    if (!cd || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-lm-cd-inner]');
    var current = cd.querySelector('[data-lm-cd-inner]');
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    var added = fresh.querySelector('[data-lm-cd-added]');
    if (added) added.hidden = !showAdded;
    return true;
  }

  function openMiniCart(open) {
    var cd = miniCart();
    if (!cd) return false;
    cd.classList.toggle('is-open', open);
    cd.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var panel = cd.querySelector('.lm-cd__panel');
      if (panel) panel.focus({ preventScroll: true });
    }
    return true;
  }

  function cartRequest(url, payload, showAdded) {
    var cd = miniCart();
    var sectionId = cd && cd.getAttribute('data-section-id');
    if (sectionId) {
      payload.sections = [sectionId];
      payload.sections_url = window.location.pathname;
    }
    if (cd) cd.classList.add('is-busy');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        if (sectionId && res.sections && renderMiniCart(res.sections[sectionId], showAdded)) {
          openMiniCart(true);
          return res;
        }
        // Fallback: theme's own drawer, then the cart page.
        var themeDrawer = document.querySelector('cart-drawer');
        if (themeDrawer && typeof themeDrawer.open === 'function') { themeDrawer.open(); return res; }
        window.location.href = cartUrl();
        return res;
      })
      .finally(function () { if (cd) cd.classList.remove('is-busy'); });
  }

  function changeLine(line, qty) {
    return cartRequest(changeUrl(), { line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0) }, false)
      .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Could not update the cart.'); });
  }

  /* ---------------- Product sliders ---------------- */
  function updateArrows(track) {
    if (!track || !track.id) return;
    var prev = document.querySelector('[data-lm-scroll="' + track.id + '"][data-dir="prev"]');
    var next = document.querySelector('[data-lm-scroll="' + track.id + '"][data-dir="next"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function initTracks(root) {
    (root || document).querySelectorAll('.lm-track').forEach(function (track) {
      if (track.__lmBound) return;
      track.__lmBound = true;
      track.addEventListener('scroll', function () { updateArrows(track); }, { passive: true });
      updateArrows(track);
    });
  }

  /* ---------------- Mobile menu ---------------- */
  function openDrawer(open) {
    var d = document.querySelector('[data-lm-drawer]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-lm-qty]');
    if (qty) {
      e.preventDefault();
      var input = qty.parentNode.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      v += qty.getAttribute('data-lm-qty') === 'plus' ? 1 : -1;
      input.value = Math.max(1, v);
      return;
    }

    var arrow = e.target.closest('[data-lm-scroll]');
    if (arrow) {
      var track = document.getElementById(arrow.getAttribute('data-lm-scroll'));
      if (!track) return;
      var card = track.querySelector('.lm-card');
      var step = card ? card.getBoundingClientRect().width + 12 : 300;
      track.scrollBy({ left: (arrow.getAttribute('data-dir') === 'next' ? 1 : -1) * step, behavior: 'smooth' });
      return;
    }

    if (e.target.closest('[data-lm-drawer-open]')) { e.preventDefault(); openDrawer(true); return; }
    if (e.target.closest('[data-lm-drawer-close]')) { e.preventDefault(); openDrawer(false); return; }

    var searchToggle = e.target.closest('[data-lm-search-toggle]');
    if (searchToggle) {
      e.preventDefault();
      var ms = document.querySelector('[data-lm-mobile-search]');
      if (ms) {
        ms.classList.toggle('is-open');
        var input2 = ms.querySelector('input');
        if (ms.classList.contains('is-open') && input2) input2.focus();
      }
      return;
    }

    // Mini cart
    if (e.target.closest('[data-lm-cd-close]')) { e.preventDefault(); openMiniCart(false); return; }

    var change = e.target.closest('[data-lm-cd-change]');
    if (change) {
      e.preventDefault();
      changeLine(change.getAttribute('data-lm-cd-change'), change.getAttribute('data-qty'));
      return;
    }

    var recAdd = e.target.closest('[data-lm-cd-add]');
    if (recAdd) {
      e.preventDefault();
      recAdd.disabled = true;
      cartRequest(addUrl(), { items: [{ id: parseInt(recAdd.getAttribute('data-lm-cd-add'), 10), quantity: 1 }] }, true)
        .catch(function () { recAdd.disabled = false; });
      return;
    }

    var cartLink = e.target.closest('[data-lm-cart-open]');
    if (cartLink && !e.defaultPrevented && miniCart()) {
      e.preventDefault();
      var added = miniCart().querySelector('[data-lm-cd-added]');
      if (added) added.hidden = true;
      openMiniCart(true);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lm-cd-input]');
    if (input) changeLine(input.getAttribute('data-lm-cd-input'), input.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openDrawer(false);
    var cd = miniCart();
    if (cd && cd.classList.contains('is-open')) openMiniCart(false);
  });

  /* ---------------- Add to cart forms ----------------
     The add is handled on the button click (and cancelled there), so the
     browser never fires a form "submit". Shopify reports product_added_to_cart
     both for a submit to /cart/add and for the /cart/add.js request itself;
     letting both happen sent every Add to Cart to Meta/GA twice. Pressing Enter
     in the form triggers this same click, so keyboard use still works. */
  function addFromForm(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;

    btn.classList.add('is-loading');
    var label = btn.textContent;
    var item = { id: parseInt(idInput.value, 10), quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) };
    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && plan.value) item.selling_plan = plan.value;

    // A product page "Buy 2 / Buy 3" set can hold different products (data-lm-items).
    var items = [item];
    var mixed = form.getAttribute('data-lm-items');
    if (mixed) {
      try {
        var list = JSON.parse(mixed);
        if (Array.isArray(list) && list.length) items = list;
      } catch (e) {}
    }

    cartRequest(addUrl(), { items: items }, true)
      .catch(function (err) {
        btn.textContent = (err && (err.description || err.message)) || 'Error';
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('form[data-lm-atc] button[type="submit"]');
    if (!btn) return;
    e.preventDefault();
    addFromForm(btn.closest('form'));
  });

  // Fallback for a submit that doesn't come from the button (e.g. another script).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lm-atc]');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTracks(); });
  } else {
    initTracks();
  }
  document.addEventListener('shopify:section:load', function (e) { initTracks(e.target); });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.lm-track').forEach(updateArrows);
  });
})();
